<template>
  <div class="mb-1">
    <div class="box p-2 position-relative overflow-hidden" :class="{'error' : isError}" data-test-id="download-doc" @click.prevent.stop="downloadFile">
      <b-row>
        <b-col cols="12" class="d-flex align-items-center">
          <b-badge v-if="item.status" class="d-inline small mr-2" :variant="statusTable[item.status]">{{ item.status.toUpperCase() }}</b-badge>
          <span class="font-condensed">{{ item.bulletin_type }}</span>
          <span v-if="item.inactive_date" class="ml-2 small">{{ 'expiresOnLabel' | translate(labels, 'CommonDateTime') }} {{ new Date(item.inactive_date) | formatDate }}</span>
        </b-col>
        <b-col cols="12" class="d-flex align-items-center justify-content-between">
          <span class="font-condensed">{{ item.description }}</span>
          <b-link :class="{'text-gray' : isError}" :disabled="isError">
            <b-icon icon="download" />
          </b-link>
        </b-col>
      </b-row>
    </div>
    <b-tooltip :variant="isError ? 'danger' : 'light'"
               noninteractive
               :target="() => $el"
               :title="isError ? translatedLabel('downloadError', 'CommonErrors') : translatedLabel('downloadDetails', 'Bulletins')"
    />
  </div>
</template>

<script>
import {STATUS_TABLE} from './TechnicalServiceBulletins'
import {bdService} from '@/services'

export default {
  conceptName: ['Bulletins', 'CommonDateTime', 'CommonErrors'],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statusTable: STATUS_TABLE,
      isError: false
    }
  },
  methods: {
    async downloadFile() {
      bdService.fetchDocumentDownloadLink(this.item.document_id).then(r => {
        const link = document.createElement('a')
        link.href = r
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
      }).catch(() => this.isError = true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.box {
  transition: background-color .15s ease-in-out;
  cursor: pointer;
  background-color: $white !important;

  &.error {
    cursor: not-allowed;
  }

  &:hover:not(.error) {
    background-color: $gray-300 !important;
  }
}
</style>
